import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SEOHead from '@/components/SEOHead';

export default function NotFound() {
  return (
    <>
      <SEOHead
        title="页面未找到 - 猎奇吃瓜"
        description="您访问的页面不存在，请返回猎奇吃瓜首页继续浏览新鲜吃瓜八卦、冷门趣味爆料。"
      />
      <Navbar />
      <main className="min-h-[60vh] flex items-center justify-center bg-background-50 pt-20">
        <div className="text-center px-4">
          <div className="w-20 h-20 mx-auto rounded-2xl bg-background-200 flex items-center justify-center mb-6">
            <i className="ri-question-mark text-4xl text-foreground-400" />
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground-900">
            404
          </h1>
          <p className="mt-3 text-lg text-foreground-600">
            这个瓜还没熟，页面找不到了
          </p>
          <p className="mt-1 text-sm text-foreground-400">
            您访问的页面不存在或已被移除
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors"
          >
            <i className="ri-home-line" />
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}